import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { TypeEvent } from '@app/shared/interfaces/accounting';

@Component({
  selector: 'app-transactions-events-log-download',
  templateUrl: './transactions-events-log-download.component.html'
})
export class TransactionsEventsLogDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();
  public typesEventList: Array<TypeEvent> = [];

  public transactionLogForm: FormGroup;
  public minDate = moment().subtract(89, 'days');
  public maxDate = moment();

  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.accountingService
    .getTypeEvent()
    .pipe(takeUntil(this.constants.destroy$))
    .subscribe(
      result => {
        this.constants.error = false;
        this.constants.loading = false;
        result.data.forEach((element: any) => {
          let typeIdentify: TypeEvent;
          typeIdentify = { name: element.name, label: element.label };
          this.typesEventList.push(typeIdentify);
        });
        this.transactionLogForm = new FormGroup(
          {
            dateStart: new FormControl('', [
              Validators.required,
              ValidationsService.isDateBetweenNinetyDaysFromToday
            ]),
            dateEnd: new FormControl('', [
              Validators.required,
              ValidationsService.isDateBetweenNinetyDaysFromToday
            ]),
            typeEvent: new FormControl('', Validators.required),
            reference: new FormControl('', [
              ValidationsService.isInvalidNumberValidator
            ]),
          },
          [ValidationsService.validateRangeDateValue]
        );
      },
      error => {
        this.constants.errorText = this.generalsService.showError(error);
        this.constants.error = true;
        this.constants.loading = false;
      }
    );
    
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transactionLogForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadTransactionsLogEvents(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'csv', result);
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }
}
